module.exports = __webpack_public_path__ + "static/media/pr_01_C.299f0946.png";